import WatchDeviceTable from './WatchDeviceTable'

export default WatchDeviceTable
